exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".failure{background-color:#ffeef0}.success{background-color:rgba(92,184,92,.2)}.started,.received{background-color:rgba(51,115,170,.2)}.pending{background-color:rgba(253,164,41,.2)}.retry{background-color:rgba(51,115,170,.2)}.revoked{background-color:rgba(119,119,119,.2)}", ""]);

// exports
